import React, { 
  useState
} from 'react'
import { Routes, Route } from 'react-router-dom'
import { 
  Game,
  GameLoader,
  Events,
  Event,
  Ranking,
  RankingEvents,
  News,
  New,
  Base,
  Content,
  GameContent,
  Redirect
} from 'basecomps'

export const GameRouter = props => {

  const [ready, loaded] = useState(false)

  return (<>
    {ready ?
      <Routes>
        <Route path="/" element={<Game showhelpcontent={ props.showhelpcontent } />}>

          { /* otras rutas inyectadas desde la app que lo utiliza */}
          {props.children}
          
          <Route path="event/:eventId/*" element={<Event showhelpcontent={ props.showhelpcontent }/>}>
            <Route path="ranking/:rankingId" element={<Ranking />} />
          </Route>
          <Route path="events/:eventType" element={<Events />}>
            <Route path=":eventId/*" element={<Event/>}>
              <Route path="ranking/:rankingId" element={<Ranking />} />
            </Route>
          </Route>
          <Route path="ranking/:rankingId" element={<RankingEvents />}>
            <Route path=":eventId" element={<Ranking type="ranking" />} />
          </Route>
          <Route path="awards" element={<Base name="awards">Premios del usuario en la partida</Base>} />
          <Route path="news" element={<News />}>
            <Route path=":newId" element={<New />} />
          </Route>
          <Route path="content/:url" element={<Content />} />
          <Route index element={<GameContent />} />
          { /* cualquier otra ruta del game, ... a la home del game */}
          <Route path="*" element={<Redirect url=".." />} />

        </Route>
      </Routes>
      :
      <GameLoader onLoaded={loaded} />
    }
  </>)
}

